import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { escapeHtml } from '../../../../utils/textFunctions'
import '../../../../styles/assets/css/admin/list1.css'
import { loadLocationWithMessage } from '../../../../actions/location'

import WarningIcon from '@material-ui/icons/Warning'

import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'

import GeneralInformation from "./general_information"
import MedicalHistory from "./medical_history"
import PsychiatricHistory from "./psychiatric_history"
import ScreenQuestionaire from './screen_questionaire'
import RoiPDF from './roi_pdf'
import AdditionalInfo from './additional_info'
import ConsentList from './consent_list'
import Csi from './csi'
import FinalStep from './final_step'

import ContactTablet from "./contact/contact_tablet"
import ContactDetermination from "./contact/contact_determination"

class TabInformation extends Component {
  constructor() {
      super();
      this.state = {
          status: false,
          message: '',
          tab_status: '3',
          uid: 0,
          pid: 0,
          doctor: 0,
          type: 0,
          date: '',
          time: '',
          duration: 0,
          patient_status: 0,
      }
  }

  componentDidMount() {
    if(this.props.match.params.secondtab > 0) {
      this.setState({
        tab_status: this.props.match.params.secondtab,
      })
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      tab_status: newValue,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    axios({
      method: 'post',
      url: connectNode + 'admin/register_patient/add_new_patient',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: this.state
    })
    .then((result) => {
        //console.log('Callback: '+result['data'])
        if(result['data'] > 0) {
          //this.props.onLoadPages(response)
          this.props.onLoadLocation('patient_list', 'Adding new patient completed!')
          this.props.history.push('/admin/patient_list')
          /*this.setState({
            message: 'Adding new patient completed!'
          })*/
        } else if(result['data'] === -1) {
          this.setState({
            message: 'This email already exist.'
          })
        } else if(result['data'] === -2) {
          this.setState({
            message: 'Adding new patient completed but system couldn\'t send email reminder!'
          })
        } else {
          this.setState({
            message: 'Something went wrong. Please try again.'
          })
        }
      }
    )
  }

  render() {
    const {
      patient_status,
      determine_bipolar,
      loan_tablet
    } = this.props

    const showAdditionalScreen =
      (patient_status === 8 ||
        patient_status === 81 ||
        determine_bipolar > 0) &&
      patient_status !== 7 &&
      patient_status !== 71 &&
      loan_tablet == null

    const tabs = [
      <Tab key="screening" label="Screening" value="1" />,
      showAdditionalScreen
        ? <Tab key="additional" label="Extra Screening" value="10" />
        : null,
      <Tab key="general" label="General" value="2" />,
      <Tab key="medical" label="Medical" value="3" />,
      <Tab key="psychiatric" label="Psychiatric" value="4" />,
      <Tab key="csi" label="CSI" value="8" />,
      <Tab key="final" label="TR&MLE" value="9" />,
      <Tab key="roi" label="ROI" value="5" />,
      <Tab key="consent" label="Consent" value="6" />,
      <Tab key="other" label="Other" value="7" />
    ].filter(Boolean)

    return (
    <div className="admin_make_appointment">
      <div className="row">
        <div className="small-12 columns tab_data1 less_space1">
          <TabContext value={this.state.tab_status}>
            <AppBar position="static">
              <TabList
                onChange={this.handleTabChange}
                aria-label="Patient information"
              >
                {tabs}
              </TabList>
            </AppBar>

            <TabPanel value="1">
              {this.state.tab_status === '1' && <ScreenQuestionaire />}
            </TabPanel>

            <TabPanel value="10">
              {this.state.tab_status === '10' && <ContactDetermination />}
            </TabPanel>

            <TabPanel value="2">
              {this.state.tab_status === '2' && <GeneralInformation />}
            </TabPanel>

            <TabPanel value="3">
              {this.state.tab_status === '3' && <MedicalHistory />}
            </TabPanel>

            <TabPanel value="4">
              {this.state.tab_status === '4' && <PsychiatricHistory />}
            </TabPanel>

            <TabPanel value="8">
              {this.state.tab_status === '8' && <Csi />}
            </TabPanel>

            <TabPanel value="9">
              {this.state.tab_status === '9' && <FinalStep />}
            </TabPanel>

            <TabPanel value="5">
              {this.state.tab_status === '5' && <RoiPDF />}
            </TabPanel>

            <TabPanel value="6">
              {this.state.tab_status === '6' && <ConsentList />}
            </TabPanel>

            <TabPanel value="7">
              {this.state.tab_status === '7' && <AdditionalInfo />}
            </TabPanel>
          </TabContext>
        </div>
      </div>
    </div>)
  }
}

const mapStateToProps = (state) => {
  //console.log('AddPatient STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TabInformation)
